import {AuthService} from '../../../auth/api/service/auth.service';
import {EntityCollectionServiceBase, EntityCollectionServiceElementsFactory} from '@ngrx/data';
import {Injector} from '@angular/core';
import {tap} from 'rxjs/operators';
import {PlainDtoModel} from '../../../common/entity/dto/plain/plainDto.model';
import {Observable, Subject} from 'rxjs';
import {MomentAdapter} from '../../../../shared/utils/moment.utils';

export class AbstractRepositoryV2<T extends PlainDtoModel> extends EntityCollectionServiceBase<T> {

    private authService: AuthService;
    public created$: Observable<T> = new Subject();
    public multipleCreated$: Observable<boolean> = new Subject();
    public multipleUpdated$: Observable<boolean> = new Subject();
    public updated$: Observable<T> = new Subject();
    public changed$: Observable<T> = new Subject();

    public deleted$: Observable<T> = new Subject();
    public dateMili;

    constructor(entityName: string, serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super(entityName, serviceElementsFactory);
        this.authService = injector.get(AuthService);
        this.authService.tokenChanged$.pipe(tap((tokenChanged) => {
            if (tokenChanged === true) {
                this.clearCache();
            }
        })).subscribe();
        this.dateMili = MomentAdapter.current().get().unix();
    }

    created(entity: T) {
        // console.log(['repository entity created', entity]);
        (this.created$ as Subject<T>).next(entity);
        this.changed(entity);
    }

    multipleUpdated() {
        // console.log('repository entities updated');
        (this.multipleUpdated$ as Subject<boolean>).next(true);
        this.changed(undefined);
    }

    multipleCreated() {
        // console.log('repository entities created');
        (this.multipleCreated$ as Subject<boolean>).next(true);
        this.changed(undefined);
    }

    updated(entity: any) {
        (this.updated$ as Subject<any>).next(entity);
        this.changed(entity);
    }
    deleted(entity: T) {
        (this.deleted$ as Subject<T>).next(entity);
        this.changed(entity);
    }

    private changed(entity: T){
        (this.changed$ as Subject<any>).next(entity);
    }

    clearCache() {
        this.changed(undefined);
    }
}
